import {
  fetch
} from '@/plugin/axios/index.js'

/**
* 详情
* @param {Object} data
*/
export function getDetail(projectId) {
  return fetch({
    url: '/sale/project/detail',
    method: 'GET',
    params: { projectId }
  })
}

/**
* 电梯列表
* @param {Object} data
*/
export function getLiftPageList(data) {
  return fetch({
    url: '/sale/project/lift/pageList',
    method: 'POST',
    data
  })
}

/**
* 保存电梯
* @param {Object} data
*/
export function saveLift(data) {
  return fetch({
    url: '/sale/project/lift/save',
    method: 'POST',
    data
  })
}

/**
* 删除电梯
* @param {Object} data
*/
export function deleteLift(data) {
  return fetch({
    url: '/sale/project/lift/delete',
    method: 'POST',
    data
  })
}



/**
* 跟踪详情
* @param {Object} data
*/
export function getProjectTrack(projectId) {
  return fetch({
    url: '/sale/projectTrack/projectTrack',
    method: 'GET',
    params: { projectId }
  })
}

/**
* 保存跟踪附件
* @param {Object} data
*/
export function addTrackFile(data) {
  return fetch({
    url: '/sale/projectTrack/addTrackFile',
    method: 'POST',
    data
  })
}

/**
* 删除跟踪附件
* @param {Object} data
*/
export function deleteTrackFile(data) {
  return fetch({
    url: '/sale/projectTrack/deleteTrackFile',
    method: 'POST',
    data
  })
}

/**
* 项目跟踪修改
* @param {Object} data
*/
export function saveTrackItem(data) {
  return fetch({
    url: '/sale/projectTrack/saveTrackItem',
    method: 'POST',
    data
  })
}

/**
* 操作记录
* @param {Object} data
*/
export function getOperatorLogList(data) {
  return fetch({
    url: '/sale/project/operatorLog/list',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/salesManagement/detail.js